var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('expression-selector',{attrs:{"selection-mode":true,"single-select":true,"batch-select":false,"crud-actions":false},on:{"new-expression":function($event){return _vm.$emit('new-expression')},"expression-selected":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }